<template>
  <div v-if="!isMobile()" class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 page">
    <div class="page-help-corner">
      <help-icon help-id="vitals" title="Help for Vitals" />
    </div>
    <span v-if="this.grouping != 'continual'" class="dateRanger"> Date range: </span>
    <select v-if="this.grouping != 'continual'" v-model="range">
      <option
        v-for="dateRange in dateRanges"
        :value="dateRange.value"
        :key="dateRange.value"
      >
        {{ dateRange.name }}
      </option>
    </select>
    <span v-if="this.grouping != 'continual'" class="dateGrouper"> Group dates: </span>
    <select v-if="this.grouping != 'continual'" v-model="selected">
      <option
        v-for="dateGroup in dateGroups"
        v-bind:value="{ id: dateGroup.value, text: dateGroup.name }"
        :key="dateGroup.name"
      >
        {{ dateGroup.name }}
      </option>
    </select>
    <span id="patientNote" class="coltext msgiconbtn"
      ><img
        title="Write a note"
        src="https://cdn4.iconfinder.com/data/icons/eon-ecommerce-i-1/32/message_letter_email_mail_send_envelope-512.png"
        width="40"
        height="40"
        @click="showNote(patient.id)"
    /></span>
    <div class="vitalsTimer">
      <span id="timer">{{ showTime() }}</span>
      <button @click="timerClick">{{ isTimed ? "Stop timer" : "Start timer" }}</button>
      <button v-if="!isTimed" @click="saveTimerNote">Save Time</button>
    </div>
    <br /><br />
    <div class="link__container">
      <router-link :to="getVitalsGrouping('all')" class="item__link all">All</router-link>
      <router-link :to="getVitalsGrouping('glucose')" class="item__link glucose"
        >Glucose</router-link
      >
      <router-link :to="getVitalsGrouping('pulse')" class="item__link pulse"
        >BP</router-link
      >
      <router-link :to="getVitalsGrouping('weight')" class="item__link weight"
        >Weight</router-link
      >
      <router-link :to="getVitalsGrouping('breathing')" class="item__link breathing"
        >SpO<sub>2</sub></router-link
      >
      <router-link :to="getVitalsGrouping('temperature')" class="item__link temperature"
        >Temp</router-link
      >
      <router-link :to="getVitalsGrouping('continual')" class="item__link continual"
        >Continual</router-link
      >
    </div>
    <note-popup
      :time="noteTime"
      ref="notePopup"
      :type="'9945X'"
      class="note__popup"
      :patient="normalizedPatient"
      :id="'note__popup' + patient.id"
      v-show="showNotePopup"
      @closeNote="showNotePopup = false"
    />
    <p v-if="this.grouping != 'continual'" class="mb-md-o mb-0">
      <small class="">
        <strong>
          Toggle
          <input
            type="checkbox"
            class="mr-1 mr-md-1"
            :checked="checked"
            @click="checked = !checked"
          />to {{ graphOrUngraphMessage }}
        </strong>
      </small>
    </p>
    <!-- <note-popup class="note__popup" :type="'Vitals'" :patient="patient" :id="'note__popup' + patient.id" style="display: none" /> -->
    <vital-signs
      v-if="this.grouping != 'continual'"
      :grouping="this.grouping"
      :range="range"
      :selected="this.selected"
    ></vital-signs>
    <watch-graph
      v-if="this.grouping != 'continual'"
      :range="this.range"
      :selected="this.selected"
      :type="'all'"
    ></watch-graph>

    <cont-graph v-if="this.grouping == 'continual'" :key="keyval" />

    <!-- <watch-list :newestProcedure="procCcd"></watch-list> -->
  </div>
  <div v-else>
    <div v-if="grouping === 'all'">
      <!-- Mobile UI for 'all' grouping -->
      <div class="form-container mobile">
        <div class="button-group mobile">
          <button class="mobile-btn" @click="navigateTo('glucose')">Glucose</button>
          <button class="mobile-btn" @click="navigateTo('pulse')">BP</button>
          <button class="mobile-btn" @click="navigateTo('weight')">Weight</button>
          <button class="mobile-btn" @click="navigateTo('breathing')">SpO₂</button>
          <button class="mobile-btn" @click="navigateTo('temperature')">Temp</button>
          <button class="mobile-btn" @click="navigateTo('continual')">Continual</button>
        </div>
        <div class="timer mobile">
          <span id="timer" class="timer-display">{{ showTime() }}</span>
          <div class="timer-buttons">
            <button @click="timerClick" class="mobile-btn timer-btn">
              {{ isTimed ? "Stop Timer" : "Start Timer" }}
            </button>
            <button v-if="!isTimed" @click="saveTimerNote" class="mobile-btn timer-btn">
              Save Time
            </button>
          </div>
        </div>
        <div class="note-icon mobile" @click="showNote(patient.id)">
          <img
            src="https://parkavenueconciergemedicine.com/wp-content/uploads/2024/08/envelope2.jpg"
            alt="Create Note"
            class="envelope-icon"
          />
        </div>
      </div>
    </div>
    <div v-else-if="grouping != 'continual'">
      <!-- Mobile UI for 'pulse' grouping -->
      <div class="container mobile">
        <div class="header mobile">
          <a href="#" class="return-link" @click.prevent="goBack">
            <span>&larr; Return</span>
          </a>
          {{ groupingHeaders[grouping] }}
        </div>

        <!-- Note Section -->
        <div class="note-section">
          <div class="note-control">
            <button class="create-note-button" @click="showNote(patient.id)">+</button>
            <span class="create-note-text">Create New Note</span>
          </div>
        </div>

        <!-- Timer Display and Controls -->
        <div class="timer-container mobile">
          <div class="timer-display">
            <span>Timer: <span>{{ showTime() }}</span></span>
          </div>
          <div class="timer-controls">
            <button class="timer-button" @click="startTimer" v-if="!isTimed">
              Start Timer
            </button>
            <button class="timer-button" @click="stopTimer" v-if="isTimed">
              Stop Timer
            </button>
            <button class="timer-button" @click="saveTimerNote" v-if="!isTimed">
              Save Time
            </button>
          </div>
        </div>

        <!-- Dropdowns for Date Range and Group Dates -->
        <div class="dropdowns mobile">
          <label for="date-range-select">Date range:</label>
          <select id="date-range-select" class="dropdown" v-model="lastX" @change="onLastXSelect">
            <option value="default">Select dates</option>
            <option
              v-for="dateGroup in dateGroups"
              :value="dateGroup.value"
              :key="'lastX'+dateGroup.value"
            >
              {{ dateGroup.name }}
            </option>
          </select>

          <!-- <label for="group-dates-select">Group dates:</label>
          <select id="group-dates-select" class="dropdown" v-model="selected">
            <option value="default">Select dates</option>
            <option
              v-for="dateGroup in dateGroups"
              :value="dateGroup.value"
              :key="dateGroup.value"
            >
              {{ dateGroup.name }}
            </option>
          </select> -->
        </div>
        <div class="orDivider">
          <span class="orDisplay">- or -</span>
        </div>
        <flat-pickr v-model="date" :config="config" @on-change="onRangeSelect" placeholder="Select a date or range" />
        <!-- BP Data Display Container -->
        <div id="bp-data-container" class="bp-data-container mobile">
          <vital-signs
            v-if="this.grouping != 'continual' && this.grouping != 'all' && startDate && endDate"
            :grouping="this.grouping"
            :start="startDate"
            :end="endDate"
          ></vital-signs>
        </div>
      </div>
    </div>
    <note-popup
      :time="noteTime"
      ref="notePopup"
      :type="'9945X'"
      class="note__popup"
      :patient="normalizedPatient"
      :id="'note__popup' + patient.id"
      v-show="showNotePopup"
      @closeNote="showNotePopup = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { CURR_API } from "@/constants/apis";
import WatchGraph from "./_partials/watch/Graph";
import WatchList from "./_partials/watch/WatchList";
import VitalSigns from "./_partials/watch/VitalSigns";
import NotePopup from "@/components/private-layouts/NotePopup.vue";
import ContinuousGraph from "./_partials/watch/ContinuousGraph.vue";
import { requestVitalSignsCodes } from "@/api/sessionApi";
import { requestExternalMeasures } from "@/api/dataApi";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { h } from "vue";
import { usePrivilegesStore } from "@/stores/privileges";
import { useSessionSelfStore } from "@/stores/sessionSelf";
import { sessionActorFrom } from "@/utils/sessionIdentity";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import HelpIcon from "@/components/help/HelpIcon.vue";

export default {
  name: "vitals-group-page",
  components: {
    "watch-graph": WatchGraph,
    "watch-list": WatchList,
    "vital-signs": VitalSigns,
    "cont-graph": ContinuousGraph,
    "note-popup": NotePopup,
    flatPickr,
    HelpIcon,
  },
  // Remove 'grouping' from props
  props: {
    procCcd: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      noteTime: "",
      checked: false,
      selected: null,
      lastX: null,
      dateGroups: [
        { name: "last week", value: 7 },
        { name: "last 2 weeks", value: 14 },
        { name: "last 30 days", value: 30 },
        { name: "last 90 days", value: 90 },
        { name: "last 365 days", value: 365 },
        { name: "all", value: 15000 },
      ],
      keyval: this.nextKeyVal() + "x",
      runningTime: 0,
      isTimed: false,
      interval: null,
      config: {
        dateFormat: "Y-m-d",
        altFormat: "F j, Y",
        mode: "range",
        altInput: true
      },
      date: null,
      startDate: null,
      endDate: null,
      showNotePopup: false,
      groupingHeaders: {
        'pulse': 'BP',
        'glucose': 'Glucose',
        'weight': 'Weight',
        'breathing': 'SpO2',
        'temperature': 'Temp'
      }
    };
  },
  mounted(){
    if (usePrivilegesStore().effectiveGranted(PRIVILEGES.APPLICATION_TIMER)) {
      this.startTimer();
    }
  },
  computed: {
    grouping() {
      return this.$route.params.grouping || "all";
    },
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient() {
      return this.allData.patient;
    },
    normalizedPatient() {
      if (!this.patient) return null;
      return {
        ...this.patient,
        first_name: this.patient.first_name || this.patient.firstName || '',
        lastname: this.patient.lastname || this.patient.lastName || '',
        date_of_birth: this.patient.date_of_birth || this.patient.dob || this.patient.dateOfBirth || '',
        psersonalID: this.patient.psersonalID || this.patient.externId || this.patient.patient_id || '',
        patient_id: this.patient.patient_id || this.patient.externId || '',
        email: this.patient.email
      };
    },
    areExternalMeasuresLoaded() {
      return this.$store.state.login.watch.areExternalMeasuresLoaded;
    },
    allDataLoaded() {
      return this.$store.state.login.phrData && true;
    },
    graphOrUngraphMessage() {
      return this.checked ? "ungraph" : "graph";
    },
    range: {
      get() {
        return this.$store.state.login.preferences.daysOfVitalsShown;
      },
      set(value) {
        this.$store.commit("login/preferences/changeDaysOfVitalsShown", value);
      },
    },
    ...mapGetters("login/preferences", {
      dateRanges: "getDaysofVitalsShownChoices",
    }),
    ...mapGetters("login/watch", {
      measuresWatching: "getMeasuresWatching",
      proceduresWatching: "getProceduresWatching",
      checkedMeasures: "getCheckedMeasures",
      vitalCcds: "getVitalSignCodes",
    }),
    hasItemInWatchList() {
      return (
        (this.measuresWatching && Object.keys(this.measuresWatching).length > 0) ||
        (this.proceduresWatching && Object.keys(this.proceduresWatching).length > 0)
      );
    },
  },
  watch: {
    grouping(newVal, oldVal) {
      console.log(`Grouping changed from ${oldVal} to ${newVal}`);
      // Perform any additional actions if necessary
    },
    $route(to, from) {
      if (!this.isMobile()) {
        let button = document.getElementsByClassName(this.grouping)[0];
        if (button) {
          button.style.backgroundColor = "#0c8687";
        }
      }
    },
    allDataLoaded: {
      handler(newValue) {
        if (newValue && !this.areExternalMeasuresLoaded) {
          let loader = this.$loading.show(
            {},
            {
              after: () => h("div", {}, "Loading data..."),
            }
          );
          if (!this.vitalCcds || this.vitalCcds.length < 1) {
            requestVitalSignsCodes()
              .then((vitalSignCodes) => {
                this.setVitalSignCodes(vitalSignCodes);
              })
              .then(requestExternalMeasures)
              .then(({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) => {
                this.addMeasures({
                  externalMeasures,
                  externalMeasCcdMeasIds,
                  externalMeasCcds,
                });
                this.setExternalMeasuresLoaded(true);
                this.tapKeyval();
              })
              .then(() => {
                loader.hide();
                loader = null;
              })
              .catch((err) => {
                loader.hide();
                loader = null;
                console.dir(err);
                // alert(err);
              });
          } else {
            requestExternalMeasures()
              .then(({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) => {
                this.addMeasures({
                  externalMeasures,
                  externalMeasCcdMeasIds,
                  externalMeasCcds,
                });
                this.setExternalMeasuresLoaded(true);
                this.tapKeyval();
              })
              .then(() => {
                loader.hide();
                loader = null;
              })
              .catch((err) => {
                loader.hide();
                loader = null;
                console.dir(err);
                // alert(err);
              });
          }
        }
      },
      immediate: true,
    },
    "$store.state.login.watch.areExternalMeasuresLoaded"(newValue) {
      if (newValue === false) {
        let d1 = Date();
        for (;;) {
          let d2 = Date();
          if (d1.toString() !== d2.toString()) break;
        }
        this.keyval = this.nextKeyVal();
      }
    },
  },
  methods: {
    ...mapActions("login/watch", [
      "setVitalSignCodes",
      "setExternalMeasuresLoaded",
      "resetCheckedVitals",
    ]),
    ...mapActions("login", ["addMeasures"]),
    ...mapGetters("login", {
      user: "getUser",
    }),
    onLastXSelect(){
      if (this.lastX == 'default') {
        this.startDate = null
        this.endDate = null
      }
      let today = new Date()
      this.endDate = today.toString()
      today.setDate(today.getDate()-this.lastX)
      this.startDate = today.toString()
    },
    getVitalsGrouping(group) {
      return {
        name: "VitalsGroup",
        params: { grouping: group },
      };
    },
    navigateTo(group) {
      this.showNotePopup = false;
      this.$router.push({ name: "VitalsGroup", params: { grouping: group } });
    },
    onRangeSelect(){
      if (!this.date) {
        this.startDate = null
        this.endDate = null
        return
      }
      let dates = this.date.split(' to ')
      this.startDate = dates[0]
      if (dates.length == 2)
        this.endDate = dates[1]
      else
        this.endDate = dates[0]
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    async saveTimerNote() {
      if (!assertPrivilegeOrAlert(
        PRIVILEGES.APPLICATION_TIMER,
        "You do not have permission to use the application timer."
      )) {
        return;
      }
      let post = {
        API_Meth: "SavePatientNote",
        PatientNote: new Date().toLocaleString(),
        patientID: this.patient.externId,
        pname: this.patient.firstName + " " + this.patient.lastName,
        notify: this.notify,
        email: this.patient.email,
        name: sessionActorFrom(this.allData, useSessionSelfStore().profile).displayName,
        startDt: "9999-12-31",
        endDt: "9999-12-31",
        startTime: "0:00",
        endTime: "0:00",
        type: "Vitals",
        timeLength: this.runningTime,
      };
      await axios
        .post(CURR_API + "/tswebhook.php", post, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.msg && res.data.msg == "Inserted") {
            alert("Time spent on this page has been saved.");
          } else {
            alert(
              "There was an error in saving the time. Please try again or contact a website administrator."
            );
          }
        });
      this.runningTime = 0;
    },
    timerClick() {
      if (this.isTimed) {
        this.stopTimer();
      } else {
        if (!assertPrivilegeOrAlert(
          PRIVILEGES.APPLICATION_TIMER,
          "You do not have permission to use the application timer."
        )) {
          return;
        }
        this.startTimer();
      }
    },
    startTimer() {
      if (!assertPrivilegeOrAlert(
        PRIVILEGES.APPLICATION_TIMER,
        "You do not have permission to use the application timer."
      )) {
        return;
      }
      if (!this.isTimed) {
        this.interval = setInterval(() => {
          this.runningTime += 1;
        }, 1000);
        this.isTimed = true;
      }
    },
    stopTimer() {
      if (this.isTimed) {
        clearInterval(this.interval);
        this.isTimed = false;
      }
    },
    showTime() {
      let time = this.runningTime;
      let hours = Math.floor(time / 3600);
      let newTime = time % 3600;
      let minutes = Math.floor(newTime / 60);
      let seconds = newTime % 60;
      if (minutes < 10) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;
      return "" + hours + ":" + minutes + ":" + seconds;
    },
    async showNote(id) {
      if (!assertPrivilegeOrAlert(
        PRIVILEGES.WRITE_NOTES,
        "You do not have permission to write notes."
      )) {
        return;
      }
      this.isTimed = false;
      clearInterval(this.interval);
      let content = {
        systemData: {
          API_Meth: "GetOrderNumber",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          let num = res.data.ordernumber;
          if (num && num != "") {
            let date = new Date();
            let tmpTime = date.toLocaleTimeString("en-US", { hour12: false }).slice(0, -3);
            this.noteTime = tmpTime.length == 7 ? `0${tmpTime}` : tmpTime;
            this.orderNum = num;
            this.showNotePopup = false;
            this.$nextTick(() => {
              this.showNotePopup = true;
              if (this.$refs.notePopup) {
                this.$refs.notePopup.startTimer();
              }
            });
          } else {
            alert(
              "Error generating order number. Contact an administrator before creating a new order."
            );
          }
        });
    },
    dateToKeyval(d) {
      return d.toString() + d.getMilliseconds();
    },
    nextKeyVal(d = null) {
      let startDate = d || new Date();
      for (;;) {
        const now = new Date();
        if (this.dateToKeyval(startDate) !== this.dateToKeyval(now)) {
          return this.dateToKeyval(now);
        }
      }
    },
    tapKeyval() {
      this.keyval = this.nextKeyVal();
    },
    loadExternalMeasures() {
      let loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, "Loading data..."),
        }
      );
      requestExternalMeasures()
        .then(({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) => {
          this.addMeasures({
            externalMeasures,
            externalMeasCcdMeasIds,
            externalMeasCcds,
          });
          this.setExternalMeasuresLoaded(true);
        })
        .then(() => {
          loader.hide();
          loader = null;
        })
        .catch((err) => {
          console.dir(err);
          // alert(err);
        });
    },
    goBack() {
      this.showNotePopup = false;
      this.$router.push({ name: "VitalsGroup", params: { grouping: "all" } });
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (!this.isMobile()) {
      let button = document.getElementsByClassName(this.grouping)[0];
      if (button) {
        button.style.backgroundColor = "#49a5a7";
      }
      this.resetCheckedVitals();
    }
    next();
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>

<style scoped lang="scss">
.page {
  margin-bottom: 4rem;
}

.page-help-corner {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.35rem;
}

.card-header {
  padding: 0.2rem;
  background-color: #fff;

  a {
    width: 100%;
    text-align: left;
  }
}

.card-body {
  padding: 0;
  font-size: 0.95rem;
}

.btn--remove {
  background-color: transparent;
  margin: 0;
  padding: 0;
  color: #ff4444;

  &:hover {
    color: #cc0000;
  }
}

.item__link {
  display: block;
  width: 100%;
  background-color: #49a5a7;
  color: #fff;
  font-size: 0.9em;
  border-radius: 3px;
  padding: 5px 0;
  text-align: center;
}

.link__container {
  display: grid;
  grid-auto-flow: column;
  column-gap: 20px;
  margin-bottom: 10px;
  width: 100%;
}

.msgiconbtn {
  float: right;
}

.vitalsTimer {
  float: right;
  margin-right: 1%;
}

.header.mobile {
  text-align: center;
  padding: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  // background-color: #f1f1f1; /* Background color for the header */
  margin-bottom: 10px;
}

.form-container.mobile {
  display: flex;
  flex-direction: column;
  padding: 10px;
  font-size: 16px;
  // background-color: #f9f9f9; /* Example background */
  // border: 1px solid #ccc; /* Example border */
}

.date-range-group.mobile,
.group-dates.mobile {
  margin-bottom: 10px;
}

.mobile-select,
.mobile-input {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.button-group.mobile {
  display: flex;
  flex-direction: column; /* Stacks the buttons */
  gap: 10px; /* Space between buttons */
  justify-content: space-between;
}

.mobile-btn {
  padding: 10px;
  font-size: 14px;
  background-color: #47a0a0;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.mobile-btn:hover {
  background-color: #3b8b8b; /* Slightly darker on hover */
}

.timer.mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  // background-color: #f1f1f1; /* Background for better visibility */
  padding: 8px;
  border-radius: 5px;
  // border: 1px solid #ddd;
}

.timer-display {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.timer-buttons {
  display: flex;
  gap: 10px; /* Space between Start and Stop buttons */
  width: 100%;
  justify-content: space-between;
}

.timer-btn {
  flex: 1;
  padding: 8px 5px;
  background-color: #47a0a0;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.timer-btn:hover {
  background-color: #3b8b8b; /* Darker blue on hover */
}

.note-icon.mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  cursor: pointer;
}

.envelope-icon {
  width: 40px; /* Adjust the size as needed */
  height: auto;
  transition: transform 0.2s;
}

.envelope-icon:hover {
  transform: scale(1.1); /* Slight zoom effect on hover */
}

/* Adjustments for smaller screens */
@media (max-width: 480px) {
  .mobile-btn {
    flex: 1 0 48%;
  }
  .timer.mobile {
    padding: 10px;
  }
  .timer-display {
    margin-bottom: 8px;
  }
}

.container {
    width: 90%;
    max-width: 600px;
    margin: auto;
    padding: 15px;
    box-sizing: border-box;
}
.header {
    text-align: center;
    background-color: #0C8687;
    color: white;
    padding: 10px 0;
    font-size: 1.5em;
    position: relative;
}

.return-link {
    position: absolute;
    left: 10px;
    top: 12px;
    color: white;
    text-decoration: none;
    font-size: 0.9em;
}
.note-section {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px 0;
    padding: 0 10px;
}
.note-label {
    font-weight: bold;
    color: #0C8687;
}
.note-control {
    display: flex;
    align-items: center;
}
.create-note-button {
    background-color: #0C8687; /* Green color */
    color: white;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    margin-right: 5px;
    font-size: 1.2em;
}
.create-note-text {
    color: #0C8687;
    font-size: 1em;
}
.timer-container {
    text-align: center;
    margin: 10px 0;
}
.timer-display {
    font-weight: bold;
    color: #0C8687;
    margin-bottom: 10px;
}
.timer-controls {
    display: flex;
    justify-content: center;
    gap: 10px;
}
.timer-button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: #0C8687;
    color: white;
    transition: background-color 0.3s;
}
.timer-button:hover {
    background-color: #086054;
}
.dropdowns {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 10px 0;
    justify-content: space-between;
}
.dropdowns label {
    margin-right: 5px;
    color: #0C8687;
    font-weight: bold;
    flex: 1 0 100%;
}
.dropdown {
    flex: 1;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ccc;
    background-color: white;
    color: #0C8687;
}
.calendar {
    margin: 20px 0;
    text-align: center;
}
.calendar input[type="text"] {
    background-color: #49A5A7;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    max-width: 300px;
    box-sizing: border-box;
}
.calendar input[type="text"]::placeholder {
    color: white;
}
.bp-data-container {
    margin-top: 20px;
}
@media only screen and (max-width: 480px) {
    .container {
        width: 100%;
        padding: 10px;
    }
    .header {
        font-size: 1.2em;
    }
    .dropdowns {
        flex-direction: column;
    }
    .dropdown {
        width: 100%;
    }
    .vitals-row {
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        gap: 5px;
    }
}
@media only screen and (max-width: 576px) {
  .note__popup {
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow-y: scroll;
  z-index: 1000;
  max-height: 700px;
  margin-top: 20%;
  }
}
.orDivider {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.orDisplay {
  font-weight: bold;
  color: #0C8687;
}
</style>
